export default __webpack_public_path__ + "static/PwC-0f5a4f04cdc6f0b2995994890fe8cc97.png";